import ProfileEdit from "../../main/modules/Profile/pages/ProfileEdit.vue";

const profileLayoutRoutes = [
    {
        path: '/profile',
        name: 'ProfileEdit',
        component: ProfileEdit,
        meta: { isAuth: true, }
    }

]

export default profileLayoutRoutes;